window.iaTheme = {
  hideExtraStickyElements: () => {
    document.getElementById('freshworks-container')?.classList.add('ia-hidden');
  },
  showExtraStickyElements: () => {
    document.getElementById('freshworks-container')?.classList.remove('ia-hidden');
  },
  setScrollbarWidth: function() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    document.documentElement.style.setProperty('--ia-scrollbar-width', `${scrollbarWidth}px`);
  }
}

window.iaTheme.pageEvents = [
  'DOMContentLoaded',
  'shopify:section:load',
  'shopify:section:select',
  'shopify:section:deselect',
  'shopify:section:reorder',
  'shopify:block:select',
  'shopify:block:deselect'
];

window.addEventListener('DOMContentLoaded', window.iaTheme.setScrollbarWidth);
window.addEventListener('resize', window.iaTheme.setScrollbarWidth);

// Color scheme responsive
window.iaTheme.colorSchemeResponsive = () => {
  const mq = window.matchMedia('(min-width: 1024px)');
  const elements = document.querySelectorAll('[data-color-scheme-mobile]');
  
  function swapClass(el) {
    const desktopScheme = el.dataset.colorSchemeDesktop;
    const mobileScheme = el.dataset.colorSchemeMobile;
    if (!desktopScheme || !mobileScheme) return;
    
    el.className = el.className.replace(/\bia-color-[^\s]+/g, '');
    el.style.opacity = 1;
    el.classList.add(mq.matches ? desktopScheme : mobileScheme);
  }
  
  function handleChange() {
    elements.forEach(swapClass);
  }
  
  mq.addEventListener('change', handleChange);
  elements.forEach(swapClass);
}
window.iaTheme.pageEvents.forEach(event =>
  document.addEventListener(event, () => {
    window.iaTheme.colorSchemeResponsive();
  })
);
